import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VehicleService } from 'src/app/management/service/vehicle.service';
import { Vehicle } from 'src/app/vehicles/model/vehicle';

@Component({
  selector: 'app-choose-vehicle-dialog',
  templateUrl: './choose-vehicle-dialog.component.html',
  styleUrls: ['./choose-vehicle-dialog.component.scss']
})
export class ChooseVehicleDialogComponent implements OnInit {

  vehicles: Array<Vehicle> = [];

  formGroup: FormGroup = new FormGroup({
    vehSideNumber: new FormControl(null, [Validators.required])
  });

  constructor(private dialogRef: MatDialogRef<ChooseVehicleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { multiple: boolean },
    private vehicleService: VehicleService) { }

  ngOnInit(): void {
    this.vehicleService.fetchVehicles()
      .subscribe(vehs => this.vehicles = vehs);
  }

  submit(): void {
    const vehsNumbers = this.formGroup.controls.vehSideNumber.value;
    this.dialogRef.close(vehsNumbers);
  }
}
